/**
 * AVISOS DO PORTAL: APURADOS OU NÃO (07/10/2026).
 *
 * `situacaoCompra` é o retrato do "Quadro Informativo" do portal (avisos, esclarecimentos, impugnações),
 * gravado pelo robô. Só existe para os portais que o robô coleta. Medido pelo Maestro em 07/10/2026, itens COM
 * PROPOSTA NOSSA: ComprasNet 163 de 164 com dado; BLL, PCP, BNC, Licitar Digital e os demais, 60 itens, ZERO.
 *
 * São duas ausências diferentes, e a tela tratava as duas igual (nenhuma marca):
 *  - `situacaoCompra` presente e `qtdeAvisos = 0`: o órgão não publicou aviso. Está apurado.
 *  - `situacaoCompra` NULO: a gente nunca olhou. Não está apurado.
 *
 * ⛔ "Não apurado" é INFORMAÇÃO, cinza, não alarme: são 60 linhas, e se todas piscarem ninguém lê mais nenhuma.
 *    A ausência de medição não é má notícia; é ausência.
 * ⛔ O item de ComprasNet sem `situacaoCompra` (1 em 07/10/2026) é "não apurado" e está certo: o portal coleta,
 *    mas este item nunca foi coletado. Não forçar para "apurado" por causa do portal.
 *
 * ⚠️ TERCEIRO CASO (08/10/2026): quadro presente SEM o contador de avisos. O ComprasBR lê o estado do portal
 *    (suspensão, motivo), mas não o conteúdo dos avisos; até 08/10 o escritor do backend inventava `qtdeAvisos: 0`
 *    quando ninguém tinha medido, e a regra antiga (`situacaoCompra == null`) via ali um quadro "apurado". O backend
 *    passou a REMOVER a chave quando não há fonte. Então: não apurado = sem quadro OU quadro sem `qtdeAvisos`.
 *    - Só o contador de AVISOS decide, porque a marca fala de avisos.
 *    - `qtdeAvisos: 0` é medição de verdade (o portal foi olhado e não há aviso) e continua APURADO. É o que protege
 *      os 166 ComprasNet com proposta, todos com a chave (medido em 08/10/2026).
 *    - `qtdeAvisos: null` conta como não apurado por defesa. Contador nulo NÃO é "medi e não há" (isso é 0): é valor
 *      estranho, e na dúvida a tela não afirma que olhou.
 */

export function avisosNaoApurados(item: { situacaoCompra?: unknown } | null | undefined): boolean {
  if (!item) return false;
  const quadro = item.situacaoCompra as { qtdeAvisos?: number | null } | null | undefined;
  return quadro == null || quadro.qtdeAvisos == null;
}

export const TEXTO_NAO_APURADO = 'avisos não apurados';

export const EXPLICACAO_NAO_APURADO =
  'O HUB não coletou os avisos do portal para esta licitação. Sem aviso aqui NÃO quer dizer que o órgão não ' +
  'publicou nada: confira avisos, esclarecimentos e impugnações no próprio portal.';
